import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { tokenReceived } from '../actions/authenticationActions'

const Token = () => {
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  useEffect(() => {
    // Parse token from URL fragment (hash) - backend sends token as #token=<TOKEN>
    const hash = window.location.hash.substring(1) // Remove the '#' prefix
    const hashParams = new URLSearchParams(hash)
    const token = hashParams.get('token')

    // Check for returnUrl in both hash and query parameters
    const returnUrl = hashParams.get('returnUrl') || searchParams.get('returnUrl')

    if (token) {
      // Clear the hash from URL immediately to prevent token from staying in browser history
      window.history.replaceState(null, '', window.location.pathname + window.location.search)

      dispatch(tokenReceived(token)).then(() => {
        toast.success('U bent succesvol ingelogd')

        if (!returnUrl) {
          navigate('/employees')
        } else {
          navigate(returnUrl)
        }
      })
    } else {
      toast.error('Token ontbreekt')
      navigate('/login')
    }
  }, [dispatch, navigate, searchParams])

  return null
}

export default Token
